import { Page } from '@touche-lts/panel-ui/dist'
// import { RootStore } from 'mobx-stores'
import { PaginationSearchBase, TriggerSearchFunc } from 'mobx-stores/utils'
import { CustomerStoresVisited } from 'models/customers'
import { Api, FetchOptions } from 'services'
import {
    CustomersTableHistorySearchProps,
    CustomerHistoryTableSortProps,
} from './customer-history-table-store.types'
import {
    customersTableNeedTimeoutHistorySearchProps, initialCustomersHistoryTableSearchProps, initialDepartmentsTablePaginationProps
} from './customer-history-table-store.utils'

export class CustomerHistoryTableStore extends PaginationSearchBase<
    CustomerHistoryTableSortProps,
    CustomersTableHistorySearchProps,
    CustomerStoresVisited
> {
    private customersApi: Api['customersApi']

    constructor(rootStore: any) {
        super({
            initialPaginationProps: initialDepartmentsTablePaginationProps,
            initialSearchProps: initialCustomersHistoryTableSearchProps,
            needTimeoutProps: customersTableNeedTimeoutHistorySearchProps
        })
        this.customersApi = rootStore.generalStore.api.customersApi
    }

    public get storeFilter(): Partial<CustomersTableHistorySearchProps> {
        return {
            raitingsMin: this.searchProps.raitingsMin,
            raitingsMax: this.searchProps.raitingsMax,
            email: this.searchProps.email,
            activeProducts: this.searchProps.activeProducts,
            country: this.searchProps.country,
            id: this.searchProps.id,
            stores: this.searchProps.stores,
            website: this.searchProps.website,
        }
    }

    // METHODS

    public handleSearchResult = (data: Page<CustomerStoresVisited>): void => {
        if (!data) return
        this.handleSearchResultPaginationProps(data)
        this.setSearchResults(data.content)
    }

    public getPageQueryParams = (
        resetPageNumber: boolean
    ): FetchOptions['pageQueryParams'] => {
        return {
            page: resetPageNumber ? 0 : this.pagination.page,
            size: this.pagination.size,
            sortDirection: this.pagination.sortDirection,
            sortProp: this.pagination.sortProp
        }
    }

    public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
        let customerId = null;
        const url = window.location.href;
        customerId = url.substring(url.lastIndexOf('/') + 1);
        let searchData = null;
        
        searchData = await this.customersApi.getCustomerStoreVisited(
            customerId,
            this.storeFilter,
            { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
        )
        this.handleSearchResult(searchData);
    }
    // COMPUTED
}